(function() {
  'use strict';

  // ── TIMER ──
  function initTimer() {
    if (window._npTimerRunning) { if (window._npTimerTick) window._npTimerTick(); return; }
    var timerEl = document.getElementById('npCartTimer');
    if (!timerEl) return;
    window._npTimerRunning = true;

    var KEY = 'np_cart_timer_end';
    var DURATION = 10 * 60;
    var expired = false;
    var timerInterval = null;
    var stored = parseInt(sessionStorage.getItem(KEY) || '0');
    if (!stored || stored < Date.now()) {
      stored = Date.now() + DURATION * 1000;
      sessionStorage.setItem(KEY, stored);
    }
    var end = stored;

    function updateTimer() {
      if (expired) return;
      var tEl = document.getElementById('npCartTimer');
      var cEl = document.getElementById('npTimerCount');
      var lEl = document.getElementById('npTimerLabel');
      if (!tEl || !cEl || !lEl) return;
      var remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (remaining === 0) {
        expired = true;
        window._npTimerRunning = false;
        clearInterval(timerInterval);
        sessionStorage.removeItem(KEY);
        tEl.classList.add('np-cart-timer--expired');
        lEl.textContent = 'Finalize agora, a oferta vai acabar!';
        cEl.style.display = 'none';
        return;
      }
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      cEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }

    window._npTimerTick = updateTimer;
    updateTimer();
    timerInterval = setInterval(updateTimer, 1000);
  }

  // ── CART SUMMARY ──
  var GIFT_HANDLE = 'gift-bag';
  var basePrice = 0, compareDisc = 0;
  var couponCode = null, couponPct = 0, couponFixed = 0;
  var giftAdded = false, giftKey = null, giftVarId = null, giftCents = 900;
  var refreshTimer = null, isRefreshing = false;
  var isGiftOperation = false;
  var comparePriceCache = {};

  function money(cents) {
    return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function(r) { return r.json(); }).catch(function() { return null; });
  }
  function postJSON(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(data) }).then(function(r) { return r.json(); }).catch(function() { return null; });
  }
  function fetchComparePrices(items, cb) {
    var handles = [];
    for (var i = 0; i < items.length; i++) {
      var h = items[i].handle;
      if (h !== GIFT_HANDLE && handles.indexOf(h) === -1 && !comparePriceCache[h]) handles.push(h);
    }
    if (handles.length === 0) { cb(comparePriceCache); return; }
    var pending = handles.length;
    for (var j = 0; j < handles.length; j++) {
      (function(handle) {
        getJSON('/products/' + handle + '.js').then(function(p) {
          if (p && p.variants && p.variants[0]) {
            var cap = p.variants[0].compare_at_price;
            var capNum = cap ? Math.round(parseFloat(cap)) : 0;
            if (capNum > 0) comparePriceCache[handle] = capNum;
          }
          if (--pending === 0) cb(comparePriceCache);
        });
      })(handles[j]);
    }
  }
  function calcFromItems(items) {
    var base = 0, comp = 0;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.handle === GIFT_HANDLE) continue;
      var price = Number(item.price) || 0;
      var qty   = Number(item.quantity) || 0;
      base += price * qty;
      var capCart = Number(item.compare_at_price) || 0;
      var capProd = comparePriceCache[item.handle] || 0;
      var cap = capCart > price ? capCart : capProd;
      if (cap > price) comp += (cap - price) * qty;
    }
    return { base: base, comp: comp };
  }
  function calcCouponDiscount() {
    if (!couponCode) return 0;
    if (couponPct > 0) return Math.round(basePrice * couponPct / 100);
    if (couponFixed > 0) return Math.min(couponFixed, basePrice);
    return 0;
  }
  function bindInstallmentBtn() {
    var btn = document.getElementById('npInstallmentBtn');
    if (btn && !btn._npBound) {
      btn._npBound = true;
      btn.addEventListener('click', function(e) { e.stopImmediatePropagation(); e.stopPropagation(); e.preventDefault(); openModal(); }, true);
    }
  }
  function renderInstallment(base) {
    var instLine = document.getElementById('npInstallmentLine');
    var instBtn  = document.getElementById('npInstallmentBtn');
    if (!instLine || !instBtn) return;
    if (base <= 0) { instLine.textContent = ''; instBtn.style.display = 'none'; return; }
    var p = 0;
    for (var x = 6; x >= 2; x--) { if (Math.floor(base / x) >= 500) { p = x; break; } }
    if (p >= 2) { instLine.textContent = 'ou ' + p + 'x de ' + money(Math.floor(base / p)) + ' sem juros'; instBtn.style.display = 'inline'; }
    else { instLine.textContent = ''; instBtn.style.display = 'none'; }
  }
  function buildCartParcelamentoTable(base) {
    var tbody = document.getElementById('npCartParcelamentoBody');
    if (!tbody) return;
    tbody.innerHTML = '';
    var taxas = [0.1313, 0.1439, 0.1562, 0.1682, 0.1801, 0.1917];
    for (var i = 1; i <= 12; i++) {
      var tr = document.createElement('tr');
      if (i === 6) tr.className = 'np-row-highlight';
      if (i > 6)  tr.className = 'np-row-juros';
      if (i <= 6) { tr.innerHTML = '<td>' + i + 'x</td><td>' + money(Math.floor(base / i)) + '</td><td>' + money(base) + '</td>'; }
      else { var taxa = taxas[i-7], total = Math.round(base*(1+taxa)); tr.innerHTML = '<td>' + i + 'x</td><td>' + money(Math.floor(total/i)) + ' <span class="np-juros-tag">c/ juros</span></td><td>' + money(total) + '</td>'; }
      tbody.appendChild(tr);
    }
  }

  // ── CORREÇÃO: openModal usa DOM como fallback se basePrice ainda for 0 ──
  function openModal() {
    var base = Math.max(0, basePrice - calcCouponDiscount());
    if (base <= 0) {
      var totalEl = document.getElementById('npTotal');
      if (totalEl) {
        var txt = totalEl.textContent.replace(/[^\d,]/g, '').replace(',', '.');
        base = Math.round(parseFloat(txt) * 100) || 0;
      }
    }
    if (base <= 0) return;
    buildCartParcelamentoTable(base);
    var modal = document.getElementById('npCartParcelamentoModal');
    if (modal && !modal.open) { modal.showModal(); modal.scrollTop = 0; }
  }

  function closeModal() {
    var modal = document.getElementById('npCartParcelamentoModal');
    if (modal && modal.open) modal.close();
  }
  document.addEventListener('click', function(e) {
    var modal = document.getElementById('npCartParcelamentoModal');
    if (!modal || !modal.open) return;
    if (e.target.classList.contains('np-modal-close') || e.target.classList.contains('np-modal-btn')) closeModal();
  });
  function render() {
    var discRow = document.getElementById('npDiscountRow'), discVal = document.getElementById('npDiscountValue');
    if (discRow && discVal) { if (compareDisc > 0) { discVal.textContent = '-' + money(compareDisc); discRow.style.display = 'flex'; } else discRow.style.display = 'none'; }
    var couponDisc = calcCouponDiscount();
    var couponRow = document.getElementById('npCouponDiscRow'), couponVal = document.getElementById('npCouponDiscValue'), couponLbl = document.getElementById('npCouponDiscLabel');
    if (couponRow) { if (couponDisc > 0 && couponCode) { if (couponVal) couponVal.textContent = '-' + money(couponDisc); if (couponLbl) couponLbl.textContent = 'Cupom ' + couponCode; couponRow.style.display = 'flex'; } else couponRow.style.display = 'none'; }
    var el = document.getElementById('npTotal');
    if (el) el.textContent = money(Math.max(0, basePrice - couponDisc + (giftAdded ? giftCents : 0)));
    renderInstallment(Math.max(0, basePrice - couponDisc));
    bindInstallmentBtn();
  }
  function showCouponTag(code) {
    var form = document.getElementById('npCouponForm'); if (form) form.style.display = 'none';
    var old  = document.getElementById('npCouponTag');  if (old)  old.remove();
    var section = document.getElementById('npCouponSection');
    var tag = document.createElement('div'); tag.className = 'np-coupon-tag'; tag.id = 'npCouponTag';
    tag.innerHTML = '<span class="np-coupon-tag-code">' + code + '</span><button type="button" class="np-coupon-tag-x" id="npCouponX">&#x2715;</button>';
    section.insertBefore(tag, form);
    document.getElementById('npCouponX').addEventListener('click', function(e) { e.stopPropagation(); e.preventDefault(); doRemoveCoupon(); });
  }
  function doRemoveCoupon() {
    couponCode = null; couponPct = 0; couponFixed = 0;
    var tag = document.getElementById('npCouponTag'); if (tag) tag.remove();
    var row = document.getElementById('npCouponDiscRow'); if (row) row.style.display = 'none';
    var form = document.getElementById('npCouponForm'); if (form) form.style.display = 'flex';
    var inp = document.getElementById('npCouponInput'); if (inp) inp.value = '';
    var err = document.getElementById('npCouponError'); if (err) err.style.display = 'none';
    render();
    postJSON('/cart/update.js', { discount: '' })
      .then(function() {
        return fetch('/discount/remove', { redirect: 'follow', credentials: 'same-origin' }).catch(function() {});
      })
      .then(function() { return getJSON('/cart.js'); })
      .then(function(cart) {
        if (!cart) return;
        fetchComparePrices(cart.items, function() {
          var result = calcFromItems(cart.items);
          basePrice   = result.base;
          compareDisc = result.comp;
          render();
        });
      });
  }
  function fetchDiscountPct(code, cb) {
    postJSON('/cart/update.js', { discount: '' })
      .then(function() {
        return fetch('/discount/remove', { redirect: 'follow', credentials: 'same-origin' }).catch(function() {});
      })
      .then(function() { return new Promise(function(r) { setTimeout(r, 400); }); })
      .then(function() {
        return fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow', credentials: 'same-origin' });
      })
      .catch(function() {})
      .then(function() { return new Promise(function(r) { setTimeout(r, 700); }); })
      .then(function() { return getJSON('/cart.js'); })
      .then(function(cart) {
        if (!cart) { cb(null); return; }
        var codes = cart.discount_codes || [];
        var aceito = false;
        for (var i = 0; i < codes.length; i++) {
          if (codes[i].code.toUpperCase() === code.toUpperCase() && codes[i].applicable !== false) {
            aceito = true; break;
          }
        }
        postJSON('/cart/update.js', { discount: '' })
          .then(function() {
            return fetch('/discount/remove', { redirect: 'follow', credentials: 'same-origin' }).catch(function() {});
          });
        if (!aceito) { cb(null); return; }
        var totalBruto = 0;
        for (var j = 0; j < cart.items.length; j++) {
          if (cart.items[j].handle === GIFT_HANDLE) continue;
          totalBruto += Number(cart.items[j].price) * Number(cart.items[j].quantity);
        }
        var totalDesconto = 0;
        for (var k = 0; k < cart.items.length; k++) {
          if (cart.items[k].handle === GIFT_HANDLE) continue;
          var allocs = cart.items[k].line_level_discount_allocations || [];
          for (var a = 0; a < allocs.length; a++) { totalDesconto += Number(allocs[a].amount) || 0; }
        }
        var cartApps = cart.cart_level_discount_applications || [];
        for (var b = 0; b < cartApps.length; b++) { totalDesconto += Number(cartApps[b].total_allocated_amount) || 0; }
        var pct   = totalBruto > 0 ? Math.round(totalDesconto / totalBruto * 10000) / 100 : 0;
        var fixed = pct <= 0 ? totalDesconto : 0;
        cb({ pct: pct, fixed: fixed });
      });
  }
  function validateAndApply(code, cb) {
    fetchDiscountPct(code, function(result) {
      if (!result) { cb(false); return; }
      cb(true, result.pct, result.fixed);
    });
  }
  function doApply() {
    var input = document.getElementById('npCouponInput');
    var errEl = document.getElementById('npCouponError');
    var btn   = document.getElementById('npCouponBtn');
    var code  = input ? input.value.trim().toUpperCase() : '';
    if (!code) return;
    if (errEl) errEl.style.display = 'none';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    couponCode = null; couponPct = 0; couponFixed = 0;
    validateAndApply(code, function(valid, pct, fixed) {
      if (btn) { btn.disabled = false; btn.textContent = 'APLICAR'; }
      if (valid) { couponCode = code; couponPct = pct || 0; couponFixed = fixed || 0; showCouponTag(code); render(); }
      else { if (errEl) errEl.style.display = 'block'; }
    });
  }
  function _onApplyClick(e) { e.stopPropagation(); e.preventDefault(); doApply(); }
  function _onApplyEnter(e) { if (e.key === 'Enter') { e.stopPropagation(); e.preventDefault(); doApply(); } }
  function wireButtons() {
    var applyBtn = document.getElementById('npCouponBtn');
    if (applyBtn) { applyBtn.removeEventListener('click', _onApplyClick); applyBtn.addEventListener('click', _onApplyClick); }
    var applyInp = document.getElementById('npCouponInput');
    if (applyInp) { applyInp.removeEventListener('keydown', _onApplyEnter); applyInp.addEventListener('keydown', _onApplyEnter); }
  }
  function refreshCart() {
    if (isRefreshing) return; isRefreshing = true;
    getJSON('/cart.js').then(function(cart) {
      isRefreshing = false; if (!cart) return;
      fetchComparePrices(cart.items, function() {
        var result = calcFromItems(cart.items); basePrice = result.base; compareDisc = result.comp; render();
      });
    });
  }
  function onCartChanged() {
    if (isGiftOperation) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 300);
  }
  document.addEventListener('cart:refresh', onCartChanged);
  document.addEventListener('cart:update', onCartChanged);
  function loadGift(cb) {
    if (giftVarId) { cb(); return; }
    getJSON('/products/' + GIFT_HANDLE + '.js').then(function(p) {
      if (p && p.variants && p.variants[0]) {
        giftVarId = p.variants[0].id;
        var raw = p.variants[0].price;
        giftCents = typeof raw === 'string' && raw.indexOf('.') !== -1 ? Math.round(parseFloat(raw) * 100) : parseInt(raw, 10);
      }
      cb();
    });
  }
  function renderGift() {
    var wrap = document.getElementById('npGiftToggle'); if (!wrap) return;
    if (giftAdded) {
      wrap.innerHTML = '<div style="display:flex;align-items:center;gap:6px;font-size:13px;"><span>Gift Bag ' + money(giftCents) + '</span><button type="button" class="np-gift-remove" id="npGiftX">&#x2715;</button></div>';
      document.getElementById('npGiftX').addEventListener('click', function(e) { e.stopPropagation(); e.preventDefault(); removeGift(); });
    } else {
      wrap.innerHTML = '<button type="button" class="np-gift-btn" id="npGiftAdd">Ver op&#231;&#245;es</button>';
      document.getElementById('npGiftAdd').addEventListener('click', function(e) { e.stopPropagation(); e.preventDefault(); addGift(); });
    }
  }
  function addGift() {
    if (!giftVarId) { loadGift(function() { if (giftVarId) addGift(); }); return; }
    isGiftOperation = true;
    postJSON('/cart/add.js', { id: giftVarId, quantity: 1 }).then(function(item) {
      if (!item) { isGiftOperation = false; return; }
      giftAdded = true; giftKey = item.key;
      renderGift(); render();
      setTimeout(function() { isGiftOperation = false; }, 500);
    });
  }
  function removeGift() {
    isGiftOperation = true;
    postJSON('/cart/change.js', { id: giftKey, quantity: 0 }).then(function() {
      giftAdded = false; giftKey = null;
      renderGift(); render();
      setTimeout(function() { isGiftOperation = false; }, 500);
    });
  }
  function goToCheckout() {
    window.location.href = couponCode ? '/checkout?discount=' + encodeURIComponent(couponCode) : '/checkout';
  }
  function wireCheckout() {
    var cartForm = document.getElementById('cart-form');
    if (cartForm && !cartForm._npWired) { cartForm._npWired = true; cartForm.addEventListener('submit', function(e) { e.preventDefault(); e.stopPropagation(); goToCheckout(); }); }
    var cb = document.getElementById('checkout');
    if (cb && !cb._npWired) { cb._npWired = true; cb.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); goToCheckout(); }); }
  }
  function initCart() {
    postJSON('/cart/update.js', { discount: '' })
      .then(function() {
        return fetch('/discount/remove', { redirect: 'follow', credentials: 'same-origin' }).catch(function() {});
      })
      .then(function() { return new Promise(function(r) { setTimeout(r, 300); }); })
      .then(function() { return getJSON('/cart.js'); })
      .then(function(cart) {
        if (!cart) { render(); loadGift(function() { renderGift(); }); return; }
        var giftItem = null;
        for (var k = 0; k < cart.items.length; k++) {
          if (cart.items[k].handle === GIFT_HANDLE) { giftItem = cart.items[k]; break; }
        }
        function setup(items) {
          fetchComparePrices(items, function() {
            var result = calcFromItems(items);
            basePrice   = result.base;
            compareDisc = result.comp;
            render();
            loadGift(function() { renderGift(); });
          });
        }
        if (giftItem) {
          postJSON('/cart/change.js', { id: giftItem.key, quantity: 0 })
            .then(function() { return getJSON('/cart.js'); })
            .then(function(c) { setup(c ? c.items : cart.items); });
        } else {
          setup(cart.items);
        }
      });
  }
  function onDrawerOpen() {
    initTimer();
    wireCheckout();
    wireButtons();
    if (!document.getElementById('npTotal')) return;
    initCart();
  }
  var cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    new MutationObserver(function(muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'open' && cartDrawer.hasAttribute('open')) {
          onDrawerOpen(); break;
        }
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
  }
  var initInterval = setInterval(function() {
    if (!cartDrawer) cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer && cartDrawer.hasAttribute('open') && document.getElementById('npCartTimer')) {
      clearInterval(initInterval);
      onDrawerOpen();
    }
  }, 100);
  setTimeout(function() { clearInterval(initInterval); }, 10000);

})();
